import { render, staticRenderFns } from "./transProvinceFiles.vue?vue&type=template&id=b2c709d6&scoped=true&"
import script from "./transProvinceFiles.vue?vue&type=script&lang=js&"
export * from "./transProvinceFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c709d6",
  null
  
)

export default component.exports